import styles from "./Error.module.scss";
import cn from "classnames";

export const Error = ({status, animate}) => {
    return (
        <div className={cn(styles.error, status ? styles.show : '', animate ? styles.active : '')}>
            <div className={cn(styles.title, 'text-body')}>Упс! Это неправильный ответ</div>
            <div className={cn(styles.desc, 'text-small')}>Попробуйте еще раз</div>
        </div>
    )
}